<template>
    <div class="qr-code-widget">
        <img :src="imgUrl" alt="">
    </div>
</template>

<script>
var QRCode = require('qrcode')
export default {
    name: "qr-widget",
    props: {
        value: {
            type: String,
            default: "none",
        },
    },
    data() {
        return {
            imgUrl: ""
        };
    },
    watch: {
        value: function (newVal, oldVal) {
            let vm = this;
            QRCode.toDataURL(vm.value, function (err, url) {
                if (err) {
                    console.log('error occurred')
                    return
                }
                vm.imgUrl = url
            });
        }
    },
    mounted() {
        let vm = this;
        QRCode.toDataURL(vm.value, function (err, url) {
            if (err) {
                console.log('error occurred')
                return
            }
            vm.imgUrl = url
        });
    },
    methods: {
    },
};
</script>
<style lang="scss" scoped>
.qr-code-widget {
    display: flex;
    width: 100%;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>